// // Footer.jsx
// import React from "react";
// import "./footer.css";
// import { Link } from "react-router-dom";
// import logo from "../assets/logo.png";

// const Footer = () => {
//   return (
//     <footer className="footer-container">
//       <div className="footer">
//         <div className="footer-content">
//           <div className="logo_box">
//             {" "}
//             <Link to="#">
//               <img src={logo} alt="logo" />
//             </Link>
//           </div>
//         </div>

     
//       </div>

//       <div className="sub-footer">
//         <div className="copyright">
//           <p>&copy; 2025 Linked.All rights reserved</p>
//         </div>

//         <div className="terms">
//           <ul type="none">
//             <li>
//               <Link to="/terms">Terms</Link>
//             </li>
//             <li>
//               <Link to="/privacy">Privacy</Link>
//             </li>
//             <li>
//               <Link to="/copyright">Copyright</Link>
//             </li>
//             <li>
//               <Link to="/imprint">Imprint</Link>
//             </li>
//             <li>
//               <Link to="/consent">Consent preferences</Link>
//             </li>
//           </ul>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;
// Footer.jsx
// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/newlogo.png";

const Footer = () => {
  return (
   <footer className="w-full bg-gray-800 border-t-2 border-gray-600 flex flex-col items-center justify-center">
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 flex justify-center py-8 md:py-10 border-b border-gray-600">
        <div className="w-full max-w-8xl flex justify-center md:justify-start">
          <div className="flex flex-col items-center gap-4">
            <div className="logo_box">
              <Link to="#">
                <img 
                  src={logo} 
                  alt="logo" 
                  className="h-8 md:h-10 lg:h-12 w-auto"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-4 md:py-6 flex flex-col sm:flex-row justify-between items-center text-gray-400 gap-4">
        <div className="copyright order-2 sm:order-1">
          <p className="text-xs sm:text-sm text-white font-normal text-center sm:text-left whitespace-nowrap">
            &copy; 2025 Linked. All rights reserved
          </p>
        </div>

        <div className="terms order-1 sm:order-2 w-full sm:w-auto">
          <ul className="flex flex-wrap justify-center gap-2 sm:gap-3 md:gap-4 list-none">
            <li>
              <Link
                to="/terms"
                className="text-xs sm:text-sm text-white hover:text-blue-400 hover:underline underline-offset-2 transition-colors duration-200 ease-in-out whitespace-nowrap"
              >
                Terms
              </Link>
            </li>
            <li>
              <Link
                to="/privacy"
                className="text-xs sm:text-sm text-white hover:text-blue-400 hover:underline underline-offset-2 transition-colors duration-200 ease-in-out whitespace-nowrap"
              >
                Privacy
              </Link>
            </li>
            <li>
              <Link
                to="/copyright"
                className="text-xs sm:text-sm text-white hover:text-blue-400 hover:underline underline-offset-2 transition-colors duration-200 ease-in-out whitespace-nowrap"
              >
                Copyright
              </Link>
            </li>
            <li>
              <Link
                to="/imprint"
                className="text-xs sm:text-sm text-white hover:text-blue-400 hover:underline underline-offset-2 transition-colors duration-200 ease-in-out whitespace-nowrap"
              >
                Imprint
              </Link>
            </li>
            <li>
              <Link
                to="/consent"
                className="text-xs sm:text-sm text-white hover:text-blue-400 hover:underline underline-offset-2 transition-colors duration-200 ease-in-out whitespace-nowrap"
              >
                Consent preferences
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;